import { GlobalController } from 'src/shared/global/GlobalController'
import Contract from './Contract'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'contract',
    component: Contract,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
